<template>
  <div class="app-container">
    <nav class="add-navigation d-block d-md-flex flex-wrap">
      <div
        @click="$router.push({ name: 'system-admin-ani-group-list' })"
        class="back-link "
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p style=" white-space: nowrap;">Back to ANI Group List</p>
      </div>
      <div class="buttons-wrapper display_block d-flex flex-wrap ">
        <div
          @click="$router.push({ name: 'system-admin-ani-group-list' })"
          class="secondary-button submit"
        >
          <secondary-button class="button_size">Cancel</secondary-button>
        </div>
        <div class="primary-button submit ">
          <primary-button @click.native="addNumber">Submit</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Import</span>
      <div class="row d-flex">

<div class="col-md-7 col-12">


  <div class="position-relative">
    <label class="field-header">Vendor</label>
    <div class="field">
      <primary-select
          type="text"
          name="vendor"
          v-model="ani.vendor_uuid"
          v-validate="'required'"
          class="name-not-showing"
          :class="{ input: true, 'is-danger': errors.has('vendor') }"
      >
        <option
            v-for="(vendor, i) in vendors"
            :key="i"
            :value="vendor.value"
        >
          {{ vendor.name }}
        </option>
      </primary-select>
      <div class="help is-danger" v-if="errors.has('vendor')">
        {{ errors.first("vendor") }}
      </div>
    </div>
  </div>
  <div >
    <label class="field-header">ANI Group</label>
    <div class="field">
      <primary-select type="text" v-model="ani.ani_group_uuid">
        <option
            v-for="(ani_group, i) in ani_groups"
            :key="i"
            :value="ani_group.value"
        >
          {{ ani_group.name }}
        </option>
      </primary-select>
    </div>
  </div>
  <div >
    <label class="field-header mt-3">Method</label>
    <div class="field">
      <primary-select
          type="text"
          class="type input"
          v-model="ani.method"
          :options="methods"
          placeholder="Select Method"
      />
    </div>
  </div>
  <div >
    <label class="field-header">Error</label>
    <div class="field">
      <primary-select
          type="text"
          class="type input"
          v-model="ani.error"
          placeholder="Select Action"
      >
        <option :value="i" v-for="(i, k) in error_list" :key="k">
          {{ i }}
        </option>
      </primary-select>
    </div>
  </div>
  <div >
    <label class="field-header">Duplicate Action</label>
    <div class="field">
      <primary-select
          type="text"
          class="type input"
          v-model="ani.duplicates_action"
          placeholder="Select Action"
      >
        <option :value="i" v-for="(i, k) in duplicates_actions" :key="k">
          {{ i }}
        </option>
      </primary-select>
    </div>
  </div>
</div>
          <!-- <div class="field-box">
            <label class="field-header">Number</label>
            <div class="field">
              <text-area
                @input="typingNumber"
                :value="ani.number"
                rows="4"
              ></text-area>
            </div>
          </div> -->

        <div class="col-md-5 col-12 mt-0 ">
          <div class="upload-container">
            <p class="pimary-input-title">Number</p>
            <app-dropzone
              @fileAdd="fileAdded($event)"
              @remove="fileRemoved($event)"
              :optionsProp="dropzoneOptions"
              class="upload-photo"
            ></app-dropzone>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddAniGroup",
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    TextArea: () => import("@/components/Inputs/TextArea.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
  },
  data: () => ({
    ani: {
      vendor_uuid: null,
      ani_group_uuid: null,
      method: null,
      error: null,
      duplicates_action: null,
    },
    methods: [
      { name: "ANI", value: "ani" },
      { name: "DNIS", value: "dnis" },
      { name: "remove_from_group", value: "remove_from_group" },
      { name: "remove", value: "remove" },
    ],
    duplicates_actions: ["skip", "override"],
    error_list: ["skip", "override"],
    vendors: [],
    ani_groups: [],
    fileId: null,
    file: null,
    enabledUpload: true,
  }),
  computed: {
    dropzoneOptions() {
      return {
        acceptedFiles: '.csv'
      }
    }
  },
  created() {
    this.GetVendorList();
    this.GetAniGroupList();
  },
  methods: {
    // File functions
    fileAdded(file) {
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false;
      }
    },
    fileRemoved() {
      this.file = null;
      // this.ani.file = null;
    },

    // transform functions
    transformVendor(item) {
      return {
        name: item.vendor_name,
        value: item.vendor_uuid,
      };
    },
    filterVendor(item) {
      return item.name;
    },
    transformAni(item) {
      return {
        name: item.ani_group_name,
        value: item.ani_group_uuid,
      };
    },
    filterAni(item) {
      return item.name;
    },

    // getting list functions
    GetVendorList() {
      this.$store.dispatch("GetVendorList", { page: 0 }).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetVendorList", { page: 0, per_page: total })
          .then((res) => {
            this.vendors = [
              { name: "Select Vendor", value: null },
              ...res.items.map(this.transformVendor).filter(this.filterVendor),
            ];
          });
      });
    },
    GetAniGroupList() {
      this.$store.dispatch("GetAniList", { page: 0 }).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetAniList", { page: 0, per_page: total })
          .then((res) => {
            this.ani_groups = [
              { name: "Select ANI Group", value: null },
              ...res.items.map(this.transformAni).filter(this.filterAni),
            ];
          });
      });
    },

    // other functions
    typingNumber(val) {
      this.ani.number = val;
    },
    async addNumber() {
      const valid = await this.$validator.validate();

      if (valid) {
        if (!this.file) {
          this.$snotify.error("File didn't select", { timeout: 6000 });
          return;
        }

        const data = new FormData();

        data.append("file", this.file);
        data.append("vendor_uuid", this.ani.vendor_uuid);
        data.append("ani_group_uuid", this.ani.ani_group_uuid || '');
        data.append("command", this.ani.method);
        data.append("on_error", this.ani.error);
        data.append("on_duplicate", this.ani.duplicates_action);

        // Request the Server
        this.$store.dispatch("ImportDidKannel", data)
          .then((res) => {
            this.$snotify.success("Number has been imported.", {
              timeout: 6000,
            });

            this.$router.push({ name: "system-admin-ani-group-list" });
          })
          .catch((err) => {
            let showMessage;
            if (err.errors) {
              this.didError = err.errors[0].contact
                ? err.errors[0].contact
                : null;
              setTimeout(() => {
                this.didError = null;
              }, 6000);
            } else if (err.response) {
              err.response.data.error.message
                ? (showMessage = err.response.data.error.message)
                : (showMessage = err.response.data.errors);
              this.$snotify.error(showMessage, { timeout: 6000 });
            } else {
              this.$snotify.error(err, { timeout: 6000 });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.name-not-showing.primary-input-container .pimary-input-title {
  display: none;
}
.help {
  margin-top: 0;
  margin-bottom: 0;
  position: absolute;
  bottom: -17px;
}
</style>
<style lang="scss" scoped>
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;

    .back-link {
      display: flex;
      align-items: center;
      font-family: "Helvetica Neue";
      fill: #51a3f3;
      color: #51a3f3;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      cursor: pointer;

      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;

      .primary-button {
        width: 110px;
        height: 40px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    padding: 0 15px 25px;
    background-color: #ffffff;

    .container-title {
      display: block;
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }
    .content {
      display: flex;

      .col {
        width: 450px;

        .field-box {
          display: flex;
          align-items: flex-start;
          width: 100%;
          margin-bottom: 15px;

          .field-header {
            width: 80px;
            margin-bottom: 0;
            padding-top: 5px;
            font-family: "Helvetica Neue";
            font-size: 13px;
            font-weight: 900;
          }
          .field {
            flex-grow: 1;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }

      }
    }
  }
}
@media (max-width: 465px) {
  .display_block{
    display: block;
  }
}
.row .input{
  margin-bottom: 20px;
}
@media (max-width: 319px) {
  .button_size{
    width: 110px !important;
  }
  .submit{
    margin-top: 16px;
  }
}
</style>

